<template>
  <div class="row f-row" style="height:100%;">
    <div class="col col-12" style="height:100%; width:100%">
      <div
        class="h-100 d-flex flex-column"
        id="skeleton-div"
        style="width: 100%;"
      >
        <svg id="svg-skeleton"></svg>
        <button class="btn__run-model" @click="runModel" v-show="hasButton">
          <i
            :class="{
              'fa fa-play': !isRunModel,
              'pi pi-spin pi-spinner': isRunModel
            }"
            aria-hidden="true"
          ></i>
          Run Model
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { D3Chart } from "@/_core/charts/D3Chart";
import { whiteGrayAlpha3 } from "@/_core/_helpers/_parametric_tools";

export default {
  props: {
    processData: { required: true },
    colorTheme: { required: true, type: Boolean, default: true },
    isRunModel: { required: false },
    hasButton: { required: false, type: Boolean, default: true }
  },
  data() {
    return {
      userSelections: {
        runModel: false
      }
    };
  },
  created() {
    // ===== create initial charts instances =====
    this.D3Chart = new D3Chart("skeleton-div", "svg-skeleton");
  },
  mounted() {
    this.createSkeletonChart();
  },
  watch: {
    isRunModel() {}
  },
  methods: {
    createSkeletonChart() {
      // === set SVG canvas
      this.svgNode = this.D3Chart.setSVG(
        0.025,
        50,
        0.4,
        45,
        0.5,
        25,
        0.4,
        75,
        this.colorTheme
      );
      if (this.svgNode.height === 0 || this.svgNode.width === 0) {
        return;
      }
      // ==== zoom setup
      this.chartBodySkeleton = this.svgNode
        .append("g")
        .attr("class", "chartBodySkeleton")
        .attr("clip-path", `url(#clipSkeleton)`);
      this.svgNode
        .append("defs")
        .append("clipPath")
        .attr("id", "clipSkeleton")
        .append("rect")
        .attr("width", this.svgNode.width)
        .attr("height", this.svgNode.height);

      const minMaxYAxis = this.getMinMax();
      this.svgNode = this.D3Chart.setAxisDateLin(
        this.svgNode,
        this.data.map(d => d.date),
        minMaxYAxis,
        true,
        false,
        false,
        [],
        "",
        this.chartBodySkeleton,
        false
      );
      this.D3Chart.bars(
        this.svgNode,
        this.data,
        5,
        "skeleton",
        whiteGrayAlpha3(this.colorTheme),
        whiteGrayAlpha3(this.colorTheme),
        "date",
        "value",
        true,
        false,
        true,
        2,
        1,
        true,
        "date",
        false,
        "",
        2,
        true,
        4,
        this.chartBodySkeleton
      );
    },
    runModel() {
      this.userSelections.runModel = true;
      this.$emit("runModel");
    },
    getMinMax() {
      let minMaxYAxis = [9, 22];
      // minMaxYAxis = this.processData.minMax(this.data, "value", "value");
      return minMaxYAxis;
    }
  },
  computed: {
    data() {
      const currentYear = new Date().getFullYear();
      const data = [];

      for (let i = 0; i < 12; i++) {
        const currentMonth = i;
        const date = new Date(currentYear, currentMonth, 1);
        data.push({
          date: date,
          value: i + 10
        });
      }
      return data;
    }
  }
};
</script>

<style>
#svg-skeleton g g.axis.axis--y g text,
#svg-skeleton g g.axis.axis--x g text {
  color: var(--graylightbackground-alpha4) !important;
}
#skeleton-div {
  position: relative;
}
.btn__run-model {
  display: flex;
  align-items: center;
  gap: 5px;
  position: absolute;
  top: 50%;
  left: 40%;
  background: var(--expo);
  padding: 8px 15px;
  border-radius: 10px;
  color: var(--textactive-2);
}
</style>
